import React from 'react';

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    { value: 'all', label: 'All', color: 'bg-[#2D2A26]' },
    { value: 'world', label: 'World', color: 'bg-[#FF6B6B]' },
    { value: 'politics', label: 'Politics', color: 'bg-[#4ECDC4]' },
    { value: 'economy', label: 'Economy', color: 'bg-[#FFE66D]' },
    { value: 'tech', label: 'Tech', color: 'bg-[#95E1D3]' },
    { value: 'science', label: 'Science', color: 'bg-[#F38181]' },
    { value: 'sports', label: 'Sports', color: 'bg-[#AA96DA]' },
    { value: 'celebrity', label: 'Celebrity Roasts', color: 'bg-[#FFB6C1]' }
  ];

  return (
    <div className="flex flex-wrap gap-3 mb-8">
      {categories.map((category) => (
        <button
          key={category.value}
          data-testid={`category-filter-${category.value}`}
          onClick={() => onCategoryChange(category.value)}
          className={`px-5 py-2 rounded-full border-2 border-black font-bold uppercase tracking-wider text-sm transition-all ${
            selectedCategory === category.value
              ? `${category.color} ${category.value === 'all' ? 'text-white' : 'text-black'} hard-shadow`
              : 'bg-white text-black hover:bg-[#F0F0F0] hard-shadow-hover'
          }`}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;